import '../../styles/field.css';
import './Accordion.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var accordionContentCSS = _7a468({defaultClassName:'_j8i7na8-2-0-1',variantClassNames:{size:{'default':'_j8i7na9-2-0-1',condensed:'_j8i7naa-2-0-1'}},defaultVariants:{},compoundVariants:[]});
export var accordionContentWrapperCSS = '_j8i7na7-2-0-1';
export var accordionDividerMarginCSS = {'default':'_j8i7na1-2-0-1',condensed:'_j8i7na2-2-0-1'};
export var accordionLabelCSS = '_j8i7na0-2-0-1';
export var accordionTriggerIconCSS = '_j8i7na3-2-0-1';
export var accordionTriggerIconEndCSS = '_j8i7na5-2-0-1';
export var accordionTriggerIconExpandedCSS = '_j8i7na6-2-0-1';
export var accordionTriggerIconStartCSS = '_j8i7na4-2-0-1';